// src/features/files/utils/getFileTypeLabel.js

/**
 * Short, human-readable type for a file chip: the extension when there is one
 * ("report.docx" → "DOCX"), otherwise the MIME subtype ("text/plain" → "PLAIN").
 * The extension wins because subtypes like
 * "vnd.openxmlformats-officedocument.wordprocessingml.document" are unreadable.
 */
export function getFileTypeLabel(file) {
  const ext = file?.filename?.includes('.') ? file.filename.split('.').pop() : '';
  if (ext && ext.length <= 5) return ext.toUpperCase();
  return file?.filetype?.split('/')[1]?.toUpperCase() || 'FILE';
}
